export enum OnboardingCustomRequestType {
  Text = 'text',
  File = 'file',
  TextAndFile = 'text-and-file',
  SectionTitle = 'section-title',
}

export interface OnboardingCustomRequest {
  id: string;
  vehicleId: string;
  title: string;
  description: string;
  documents: Array<{
    name: string;
    path: string;
  }>;
  type: OnboardingCustomRequestType;
  isRequired: boolean;
}

export interface OnboardingCustomRequestWithPreviewUrls
  extends OnboardingCustomRequest {
  documents: Array<{
    name: string;
    path: string;
    previewUrl: string;
  }>;
}
